import "clsx";
import { W as Workshops } from "../../../chunks/Workshops.js";
function _page($$renderer) {
  Workshops($$renderer, {});
}
export {
  _page as default
};
